if (!customElements.get('shadowfax-tracker')) {
  customElements.define('shadowfax-tracker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.querySelector('form').addEventListener('submit', (event) => {
        event.preventDefault();
        const input = this.querySelector('[name="awb"]');
        const awb = input.value.trim();

        if (!/^[A-Za-z0-9]+$/.test(awb)) {
          input.setCustomValidity('Enter your AWB number using letters and numbers.');
          input.reportValidity();
          return;
        }

        const trackingUrl = /^SF/i.test(awb)
          ? `https://tracker.shadowfax.in/#/awb/${encodeURIComponent(awb)}/`
          : `https://www.delhivery.com/track/package/${encodeURIComponent(awb)}`;

        window.location.assign(trackingUrl);
      });

      this.querySelector('[name="awb"]').addEventListener('input', (event) => {
        event.target.setCustomValidity('');
      });
    }
  });
}
